export enum Language {
  ENGLISH = 'en',
  GERMAN = 'de',
  ITALIAN = 'it',
  SPANISH = 'es',
  JAPANESE = 'ja',
  FRENCH = 'fr',
  POLISH = 'pl',
}
